import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { UserDetailPage } from "@/features/users/pages/user-detail-page/user-detail-page";

export const Route = createFileRoute("/_authenticated/admin/users/$remoteId")({
	head: () => pageTitle("User"),
	component: UserDetailPage,
});
